import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/product.actions';

import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { TrashIcon, EditIcon, DuplicateIcon } from '../../../../images/icons/WrapSvg';

class Index extends React.Component {
    handleEdit = () => {
        this.props.history.push(`/xef/products/${this.props.id}`);
    };

    handleDuplicated = () => {
        this.props.duplicateProduct(this.props.id).catch((error) => {
            this.props.onError(error.message);
        });
    };

    handleDelete = () => {
        this.props.deleteProduct(this.props.id).catch((error) => {
            this.props.onError(error.message);
        });
    };

    render() {
        const { intl, anchorEl, handleClose } = this.props;
        return (
            <Menu
                id="recipe-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem className={'bg_ice_blue'} onClick={this.handleEdit}>
                    <ListItemIcon className={'icon c_bluish'}>
                        <EditIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        classes={{ primary: 'barlow_semibold_label c_bluish' }}
                        inset
                        primary={intl.formatMessage({ id: 'popup_edit_menuitem' })}
                    />
                </MenuItem>
                <MenuItem className={'bg_ice_blue'} onClick={this.handleDuplicated}>
                    <ListItemIcon className={'icon c_bluish'}>
                        <DuplicateIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        classes={{ primary: 'barlow_semibold_label c_bluish' }}
                        inset
                        primary={intl.formatMessage({ id: 'popup_duplicate_menuitem' })}
                    />
                </MenuItem>
                <MenuItem className={'bg_ice_blue'} onClick={this.handleDelete}>
                    <ListItemIcon className={'icon c_lipstick'}>
                        <TrashIcon />
                    </ListItemIcon>
                    <ListItemText
                        classes={{ primary: 'barlow_semibold_label c_lipstick' }}
                        inset
                        primary={intl.formatMessage({ id: 'popup_delete_menuitem' })}
                    />
                </MenuItem>
            </Menu>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    null,
    mapDispatchToProps,
)(withRouter(injectIntl(Index)));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/products/TableMenu.js